// extracted by mini-css-extract-plugin
export default {"mediaColumnWrapper":"_d5efaebf","mainMedia":"_8b24ca11"};